import { useEffect, useRef } from 'react';
import { terminalLog, sendToTerminal } from '../../../lib/terminalLogger';

interface UseOrderDetailsResetParams {
  pedidoId?: string;
  itemId?: string;
  setSelectedObjects: React.Dispatch<React.SetStateAction<any[]>>;
  snapshotAppliedRef: React.MutableRefObject<boolean>;
}

/**
 * Hook para resetar selectedObjects ao trocar pedido/item (garante estado limpo)
 */
export function useOrderDetailsReset({
  pedidoId,
  itemId,
  setSelectedObjects,
  snapshotAppliedRef
}: UseOrderDetailsResetParams) {
  const lastPedidoRef = useRef<any>(null);
  const lastItemRef = useRef<any>(null);
  
  useEffect(() => {
    // ⚠️ GUARD: Só resetar se pedido/item REALMENTE mudaram
    const pedidoChanged = lastPedidoRef.current !== pedidoId;
    const itemChanged = lastItemRef.current !== itemId;
    
    if (!pedidoChanged && !itemChanged) {
      // ✅ Log removido - reduzir verbosidade
      return; // Não resetar se não houve mudança
    }
    
    // ✅ Log removido - reduzir verbosidade
    
    setSelectedObjects([]);
    snapshotAppliedRef.current = false;
    lastPedidoRef.current = pedidoId;
    lastItemRef.current = itemId;
    
    terminalLog.debug('[UI] RESET_STATE', { 
      pedidoId, 
      itemId, 
      pedidoChanged,
      itemChanged,
      reason: 'mount_or_change',
      timestamp: Date.now() 
    });
  }, [pedidoId, itemId, setSelectedObjects, snapshotAppliedRef]);
}

